/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnlinkAliasFromBand
 */
export interface UnlinkAliasFromBand {
    /**
     * 
     * @type {string}
     * @memberof UnlinkAliasFromBand
     */
    aliasId: string;
}

/**
 * Check if a given object implements the UnlinkAliasFromBand interface.
 */
export function instanceOfUnlinkAliasFromBand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "aliasId" in value;

    return isInstance;
}

export function UnlinkAliasFromBandFromJSON(json: any): UnlinkAliasFromBand {
    return UnlinkAliasFromBandFromJSONTyped(json, false);
}

export function UnlinkAliasFromBandFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnlinkAliasFromBand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aliasId': json['alias_id'],
    };
}

export function UnlinkAliasFromBandToJSON(value?: UnlinkAliasFromBand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'alias_id': value.aliasId,
    };
}

